import { render, staticRenderFns } from "./CorsAllowedOrigins.vue?vue&type=template&id=2b148a0d&"
import script from "./CorsAllowedOrigins.vue?vue&type=script&lang=js&"
export * from "./CorsAllowedOrigins.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports